import { render, staticRenderFns } from "./RegionEdu.vue?vue&type=template&id=de7b9c5a&"
import script from "./RegionEdu.vue?vue&type=script&lang=js&"
export * from "./RegionEdu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports